<template>
  <div style="float: right">
    <span style="color: #1890ff; cursor: pointer" @click="showDetail">店铺提报情况{{ reportNum }}</span>
    <!-- dialog  -->
    <v-dialog v-model="visible" :config="dialogConfig">
      <div slot="content">
        <div style="text-align: right; margin-bottom: 10px">
          <el-button type="primary" size="mini" @click="showFallbackRecords">回退记录</el-button>
        </div>
        <el-table :data="tableData">
          <el-table-column label="平台名称" prop="platformName"></el-table-column>
          <el-table-column label="店铺名称" width="200px" prop="storeName">
            <template slot-scope="scope">
              <remark :content="scope.row.storeName"></remark>
            </template>
          </el-table-column>
          <el-table-column label="店铺简称" prop="shortName">
            <template slot-scope="scope">
              <remark :content="scope.row.shortName"></remark>
            </template>
          </el-table-column>
          <el-table-column label="是否提报" prop="submission">
            <template slot-scope="scope">
              <span v-if="scope.row.submission != 0">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="提报人" prop="submissionBy">
            <template slot-scope="scope">
              <remark :content="scope.row.submissionBy"></remark>
            </template>
          </el-table-column>
          <el-table-column label="提报时间" width="150px" prop="submissionDate">
            <template slot-scope="scope">
              <remark :content="scope.row.submissionDate"></remark>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" @click="fallback(row)" v-if="+row.submission">回退</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- pagination -->
        <div style="text-align: right; margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="fallbackVisible" :config="fallbackDialogConfig">
      <div slot="content">
        <el-table :data="tableDataBack.records" border height="320" v-loading="loadingBack">
          <el-table-column label="平台名称" prop="platformName"></el-table-column>
          <el-table-column label="店铺名称" prop="storeName"></el-table-column>
          <el-table-column label="店铺简称" prop="storeShortName"></el-table-column>
          <el-table-column label="提报人" prop="submissionBy"></el-table-column>
          <el-table-column label="提报时间" prop="submissionDate"></el-table-column>
          <el-table-column label="回退人" prop="rollbackBy"></el-table-column>
          <el-table-column label="回退时间" prop="rollbackDate"></el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            @size-change="handleSizeChangeBack"
            @current-change="handleCurrentChangeBack"
            :current-page="tableDataBack.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableDataBack.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableDataBack.total"
          >
          </el-pagination>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js';
import { mapGetters } from 'vuex';
export default {
  mixins: [mixin],
  data() {
    return {
      visible: false,
      fallbackVisible: false,
      loadingBack: false,
      dialogConfig: {
        title: '店铺提报情况',
        showButton: false,
        width: '60%',
      },
      fallbackDialogConfig: {
        title: '回退记录',
        showButton: false,
        width: '60%',
      },
      tableData: [],
      fallbackTableData: [],
      paginationOpt: {
        pageSizes: [10, 30],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableDataBack: {
        records: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      // 提报店铺数量
      reportNum: 'reportNum',
    }),
  },
  mounted() {},
  methods: {
    showDetail() {
      this.visible = true;
      this.init();
    },
    async init() {
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          planTime: this.planTime,
        },
      };
      let res = await this.$q.preSalePlan.storeSubmissionList({ data });
      if (res.success && res.data && res.data.records.length) {
        this.tableData = res.data.records;
        this.paginationOpt.total = res.data.total;
      } else {
        this.tableData = res.data.records;
        this.paginationOpt.total = 0;
      }
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    async fallback(row) {
      let status = await this.$confirm('是否确认回退该店铺提报状态?,', '回退提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let data = {
        storeId: row.storeId,
        subTime: this.planTime,
      };
      this.$q.preSalePlan.planRollback({ data: data }).then((res) => {
        if (res.success) {
          this.$message('回退成功');
          this.$store.dispatch('preSalePlan/get_reportNum', false);
          this.init();
        }
      });
    },
    showFallbackRecords() {
      this.fallbackVisible = true;
      this.loadFallbackRecords();
    },
    async loadFallbackRecords() {
      this.loadingBack = true;
      // 加载回退记录数据的逻辑
      let data = {
        filterData: {
          planTime: this.planTime,
        },
        pageNum: this.tableDataBack.pageNum,
        pageSize: this.tableDataBack.pageSize,
      };
      this.$q.preSalePlan
        .planRollbackListPage({ data: data })
        .then((res) => {
          this.tableDataBack = res.data;
        })
        .finally((_) => {
          this.loadingBack = false;
        });
    },
    handleSizeChangeBack(val) {
      this.tableDataBack.pageSize = val;
      this.tableDataBack.pageNum = 1;
      this.loadFallbackRecords();
    },

    handleCurrentChangeBack(val) {
      this.tableDataBack.pageNum = val;
      this.loadFallbackRecords();
    },
  },
};
</script>

<style lang="stylus" scoped>
.footer {
  text-align: right
  margin-top: 10px
}
</style>
